function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.3335 0.0834961C3.45068 0.0834961 0.333496 3.22803 0.333496 7.0835C0.333496 10.9663 3.45068 14.0835 7.3335 14.0835C11.189 14.0835 14.3335 10.9663 14.3335 7.0835C14.3335 3.22803 11.189 0.0834961 7.3335 0.0834961ZM10.478 5.88037L6.97803 9.38037C6.84131 9.54443 6.6499 9.59912 6.4585 9.59912C6.23975 9.59912 6.04834 9.54443 5.91162 9.38037L4.16162 7.63037C3.86084 7.32959 3.86084 6.86475 4.16162 6.56396C4.4624 6.26318 4.92725 6.26318 5.22803 6.56396L6.4585 7.76709L9.41162 4.81396C9.7124 4.51318 10.1772 4.51318 10.478 4.81396C10.7788 5.11475 10.7788 5.57959 10.478 5.88037Z",
  fill: "currentColor"
});

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4cfcffe8.svg";
export { ForwardRef as ReactComponent };